// TDS2 SHIM — replace with @salesforce/trailhead-ui formatAgentforceChatTime when TDS2 lands.
export default function formatAgentforceChatTime(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  return d
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
    .toLowerCase();
}
